import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { Box } from '../box';
import { makeEnum, withVersion } from '../utils';
export const ColorIndicatorSize = makeEnum(10, 18, 24);
const ColorIndicatorImpl = React.forwardRef((props, ref) => {
    const { color, size = 24, className, 'data-role': dataRole = 'color-indicator', 'data-role-value': dataRoleValue } = props;
    return (_jsx(Box, { ref: ref, className: className, "data-role": dataRole, "data-role-value": dataRoleValue, sx: {
            width: size,
            height: size,
            minWidth: size,
            borderRadius: '50%',
            backgroundColor: color,
            border: '1px solid',
            borderColor: 'rgba(0, 0, 0, 0.1)'
        } }));
});
ColorIndicatorImpl.displayName =
    'ColorIndicator';
export const ColorIndicator = withVersion(ColorIndicatorImpl, '1.0.0');
